module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_plus-8d80bef08fffeb95ffdc6596ff745901.svg";